(() => {
  const LOADED_FLAG = "__pakoCheckoutRedirectLoaded";

  if (window[LOADED_FLAG]) return;
  window[LOADED_FLAG] = true;

  function getRootUrl() {
    const rootUrl = window.Shopify?.routes?.root || window.themeCore?.objects?.routes?.root_url || "/";
    const normalizedRootUrl = String(rootUrl || "/").trim();

    if (!normalizedRootUrl || normalizedRootUrl === "/") return "/";
    return `/${normalizedRootUrl.replace(/^\/+|\/+$/g, "")}/`;
  }

  function getCustomCheckoutUrl() {
    return `${getRootUrl()}cart?view=pl-checkout`;
  }

  function isNativeCheckoutUrl(value) {
    const url = String(value || "").trim();
    if (!url) return false;

    try {
      const parsed = new URL(url, window.location.origin);
      return /\/(?:[a-z]{2}\/)?(?:a\/)?checkout(?:\/|\?|#|$)/i.test(parsed.pathname);
    } catch (_error) {
      return /\/(?:[a-z]{2}\/)?(?:a\/)?checkout(?:\/|\?|#|$)/i.test(url);
    }
  }

  function isCheckoutSubmitter(element) {
    if (!element) return false;
    const name = String(element.getAttribute?.("name") || "").toLowerCase();
    const id = String(element.id || "").toLowerCase();
    const className = String(element.className || "").toLowerCase();
    return name === "checkout" || id.includes("checkout") || className.includes("checkout");
  }

  function redirectToCustomCheckout(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
    }

    window.location.assign(getCustomCheckoutUrl());
  }

  function rewriteReturnToFields(root = document) {
    root.querySelectorAll?.('input[name="return_to"]').forEach((input) => {
      if (isNativeCheckoutUrl(input.value)) {
        input.value = getCustomCheckoutUrl();
      }
    });
  }

  document.addEventListener("click", (event) => {
    const target = event.target;
    if (target?.closest?.("[data-pako-custom-checkout]")) return;

    const link = target?.closest?.("a[href]");

    if (link && isNativeCheckoutUrl(link.getAttribute("href"))) {
      redirectToCustomCheckout(event);
      return;
    }

    const control = target?.closest?.("button,input");
    if (isCheckoutSubmitter(control)) {
      redirectToCustomCheckout(event);
    }
  }, true);

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (form?.closest?.("[data-pako-custom-checkout]")) return;

    const submitter = event.submitter || document.activeElement;
    const action = form?.getAttribute?.("action") || "";

    if (isNativeCheckoutUrl(action) || isCheckoutSubmitter(submitter)) {
      redirectToCustomCheckout(event);
    }
  }, true);

  document.addEventListener("DOMContentLoaded", () => rewriteReturnToFields());
  document.addEventListener("shopify:section:load", (event) => rewriteReturnToFields(event.target));
})();
